export default {
  APPLICATION_NAME: "Staza",
  DEFAULT_ICON_URL: "https://staza-assets.s3-eu-west-1.amazonaws.com/staza/logo/staza-logo.png"
};
